export const sources={webp:"__VITE_ASSET__BFvf93zl__ 48w"};export const img={src:"__VITE_ASSET__BpPCszQJ__",w:48,h:48};export default{sources:sources,img:img};